import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import ActionButton from '@westwing/ui-kit/ActionButton';
import { hideOverlay } from '../../../redux/overlays/actions';
import useTranslator from '../../../hooks/useTranslator';
import { OverlayId } from '../types';
import Flyout from '../GenericFlyout';
import { BellaTestIds } from '../../../../common/qaIds';
import FilterGroup from './FiltersGroup';
import { useFilterState } from 'Client/components/Looks/hooks/useFilterState';

const StyledFiltersContainer = styled.div`
    padding: 10px 20px;
`;

const MarginActionButton = styled(ActionButton)`
    margin-top: 10px;
`;

const FiltersFlyout: React.FC = () => {
    const { appliedStyleFilter, styleFilter, onFilterValueChange, clearStylesFilter } = useFilterState();
    const dispatch = useDispatch();
    const t = useTranslator();

    const completeFiltering = () => {
        dispatch(hideOverlay(OverlayId.LOOKS_FILTERS_FLYOUT));
    };

    const resetFilter = () => {
        clearStylesFilter();
        dispatch(hideOverlay(OverlayId.LOOKS_FILTERS_FLYOUT));
    };

    return (
        <Flyout identifier={OverlayId.LOOKS_FILTERS_FLYOUT} title={t('')}>
            <StyledFiltersContainer>
                <FilterGroup
                    group={styleFilter}
                    appliedFilter={appliedStyleFilter.values}
                    handleValueChange={onFilterValueChange}
                />
            </StyledFiltersContainer>
            <StyledFiltersContainer>
                <ActionButton
                    data-testid={BellaTestIds.filtersResetBtn}
                    kind="secondary"
                    name="clear"
                    onClick={resetFilter}
                >
                    {t('Reset filter')}
                </ActionButton>
                <MarginActionButton
                    data-testid={BellaTestIds.filtersApplyBtn}
                    kind="primary"
                    name="submit"
                    onClick={completeFiltering}
                >
                    {t('Apply filters')}
                </MarginActionButton>
            </StyledFiltersContainer>
        </Flyout>
    );
};

export default FiltersFlyout;
